import styled from 'styled-components';
export const Wrapper = styled.div `
  overflow: hidden;
  height: 25rem;

  embed,
  img {
    width: 100%;
    height: 100%;
    border-radius: ${({ theme }) => theme.borderRadius.mediumHigh};
  }
`;
//# sourceMappingURL=styles.js.map